export function throwTestError(message) {
    throw new Error(message);
}
